import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import type { PageContextRequestV1 } from "@/generated/copilot-contracts";
import { pageContextFor } from "@/lib/page-context";

/** The page-context hint for the screen the clinic is on right now, or `null`
 * when this screen publishes none (SCRUM-306). */
export function usePageContext(): PageContextRequestV1 | null {
  const { pathname } = useLocation();
  return useMemo(() => pageContextFor(pathname), [pathname]);
}
